import { useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { useSettings } from "@/hooks/useSettings";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Mail } from "lucide-react";

export default function Contact() {
  const { data: s } = useSettings();
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await api.post("/contact", form); toast.success("Votre message a bien été envoyé."); setForm({ name: "", email: "", subject: "", message: "" }); }
    catch (err) { toast.error(apiError(err)); } finally { setLoading(false); }
  };
  return (
    <div className="max-w-2xl mx-auto px-5 sm:px-8 py-16">
      <p className="font-overline text-terracotta text-center mb-3">Nous écrire</p>
      <h1 className="font-heading text-4xl sm:text-5xl text-ink tracking-tight text-center">Contact</h1>
      <p className="text-ink-muted text-center mt-3">Une question sur nos eBooks ou votre commande ? Écrivez-nous.</p>
      {s?.support_email && s.support_email !== "À COMPLÉTER" && (
        <p className="text-center text-sm text-ink-muted mt-2 flex items-center justify-center gap-2"><Mail className="h-4 w-4" /> {s.support_email}</p>
      )}
      <form onSubmit={submit} className="bg-cream border border-line rounded-lg p-7 mt-8 space-y-4">
        <div className="grid sm:grid-cols-2 gap-4">
          <div><Label htmlFor="name">Nom</Label><Input id="name" value={form.name} onChange={set("name")} required className="bg-sand border-line mt-1" data-testid="contact-name" /></div>
          <div><Label htmlFor="email">E-mail</Label><Input id="email" type="email" value={form.email} onChange={set("email")} required className="bg-sand border-line mt-1" data-testid="contact-email" /></div>
        </div>
        <div><Label htmlFor="subject">Sujet</Label><Input id="subject" value={form.subject} onChange={set("subject")} required className="bg-sand border-line mt-1" data-testid="contact-subject" /></div>
        <div><Label htmlFor="message">Message</Label><Textarea id="message" value={form.message} onChange={set("message")} required rows={5} className="bg-sand border-line mt-1" data-testid="contact-message" /></div>
        <Button type="submit" disabled={loading} className="bg-terracotta hover:bg-terracotta-dark text-white" data-testid="contact-submit">{loading ? "Envoi…" : "Envoyer le message"}</Button>
      </form>
    </div>
  );
}
